export const enApiHealth = {
	title: "API Health",
	subtitle:
		"Uptime and response-schema checks for the external RapidAPI providers. A provider that answers 200 with a renamed field or an empty body breaks enrichment silently — these checks are what make that visible.",
	probesOn: "Synthetic probes running hourly",
	probesOff: "Synthetic probes are off — statuses come from production traffic only",
	cost: "{{calls}} probe calls/month · approx. {{cost}} €",
	costUnpriced: "{{count}} endpoint(s) have no configured price, so the estimate is a lower bound",
	healthy: "{{healthy}}/{{total}} healthy",
	neverChecked: "Never checked",
	lastChecked: "Checked {{when}}",
	monitoring: {
		PROBED: "Actively probed",
		PASSIVE_ONLY: "Judged from production traffic only",
	},
	status: {
		OK: "OK",
		DRIFT: "Drift",
		INPUT_REJECTED: "Input rejected",
		EMPTY: "Empty",
		BREAKING: "Breaking",
		DOWN: "Down",
		UNKNOWN: "Unknown",
	},
	statusHint: {
		OK: "Carries every field we read.",
		DRIFT: "The provider added something we do not read. Nothing is broken.",
		INPUT_REJECTED:
			"The provider refused the input we sent it — an unknown company or profile. The endpoint is healthy; our input data is not.",
		EMPTY: "Answered, but with nothing usable in it.",
		BREAKING: "A field our code reads is missing or changed type.",
		DOWN: "No usable response at all.",
		UNKNOWN: "No check has run for this endpoint yet.",
	},
	detail: {
		title: "Recent checks",
		empty: "No checks recorded yet.",
		latency: "Latency",
		mode: "Source",
		violations: "What failed",
		sample: "Sample request #{{id}}",
		close: "Close",
	},
	modes: {
		ACTIVE: "Probe",
		PASSIVE: "Traffic",
	},
	error: "Could not load the health board.",
};
